type WithCidrs = { cidrs: readonly string[] };

/** Returns the IPv4 CIDR from a network, if one exists. */
export function getCidrV4({ cidrs }: WithCidrs): string | undefined {
  return cidrs.find((cidr) => cidr.includes('.'));
}

/** Returns the IPv6 CIDR from a network, if one exists. */
export function getCidrV6({ cidrs }: WithCidrs): string | undefined {
  return cidrs.find((cidr) => cidr.includes(':'));
}

/** Returns every CIDR but the IPv4 one — the entries an IPv4-only control has no say over. */
export function getCidrsExceptV4({ cidrs }: WithCidrs): string[] {
  return cidrs.filter((cidr) => !cidr.includes('.'));
}
